module.exports = __webpack_public_path__ + "img/2_gold.af3823a4.svg";